import React from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';
// useParams only for BotActivityLegacyRedirect

export function IntegrationLegacyRedirect() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const tab = params.get('tab');
  const base = tab === 'api' ? '/channels/api' : '/channels/widgets';
  const assistantId = params.get('assistant_id');
  const action = params.get('action');
  const next = new URLSearchParams();
  if (assistantId) next.set('assistant_id', assistantId);
  if (action) next.set('action', action);
  const qs = next.toString();
  return <Navigate to={`${base}${qs ? `?${qs}` : ''}`} replace />;
}

export function IntegrationWidgetsLegacyRedirect() {
  const location = useLocation();
  const rest = location.pathname.replace(/^\/integration\/widgets\/?/, '');
  const suffix = rest ? `/${rest}` : '';
  return <Navigate to={`/channels/widgets${suffix}${location.search}`} replace />;
}

export function BotsLegacyRedirect() {
  const location = useLocation();
  const path = location.pathname.replace(/^\/bots/, '/channels/bots');
  return <Navigate to={`${path}${location.search}`} replace />;
}

export function BotActivityLegacyRedirect() {
  const { botId, sessionId } = useParams();
  if (sessionId) {
    return <Navigate to={`/channels/bots/${botId}/activity/${encodeURIComponent(sessionId)}`} replace />;
  }
  return <Navigate to={`/channels/bots/${botId}/activity`} replace />;
}
